<template>
  <v-row
    v-if="managementToken || isDevelopment"
    style="height: 100%"
    class="ma-0 pa-0"
  >
    <v-col cols="7" class="pa-0 ma-0 pa-5">
      <v-card elevation="5" class="drugs-management ma-0 pa-1">
        <v-row
          v-if="!archiveMode"
          class="ma-0 pa-0 pt-2 px-2"
          align="start"
          justify="space-between"
        >
          <v-col cols="2" class="ma-0 pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  @click="archiveMode = true"
                  color="primary"
                  class="text-none"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>{{ mdiFile }}</v-icon>
                </v-btn>
              </template>
              <span>Visão de arquivo</span>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="ma-0 pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  @click="classesModelManagement = true"
                  color="primary"
                  class="text-none"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>{{ mdiFilterVariant }}</v-icon>
                </v-btn>
              </template>
              <span>Gestão de Classes</span>
            </v-tooltip>
            <v-dialog width="700" v-model="classesModelManagement">
              <v-card class="white" height="300">
                <v-row class="ma-0 pa-0">
                  <v-btn icon @click="classesModelManagement = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                  </v-btn>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <v-col cols="6" class="pa-0 ma-0 pl-2 pr-1">
                    <v-select
                      v-model="category"
                      class="pt-5"
                      :items="categories"
                      item-text="portugueseName"
                      return-object
                      label="Categoria"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="6" class="pa-0 ma-0 pr-2 pl-1">
                    <v-select
                      v-model="classModel"
                      class="pt-5"
                      :items="classesByCategory"
                      item-text="name"
                      return-object
                      label="Classes"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0 mb-4" justify="end">
                  <v-col cols="6" class="pa-0 ma-0 pr-2 pl-1">
                    <v-btn
                      :disabled="!classModel"
                      class="text-none red white--text"
                      @click="
                        () => {
                          classesModelManagement = false;
                          deleteSelectedClass({
                            classModel: classModel,
                            classes: classes,
                          });
                        }
                      "
                      block
                    >
                      <v-icon>{{ mdiClose }}</v-icon>
                      <p class="ma-0 pa-0 ml-2">Deletar seleção</p>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="ma-0 pa-0">
                  <v-col cols="6">
                    <v-text-field
                      v-model="classModelName"
                      label="Nome da Classe"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pa-0 ma-0 pr-2 pl-1">
                    <v-btn
                      :disabled="!classModelName"
                      class="text-none success white--text mt-5"
                      @click="
                        () => {
                          classesModelManagement = false;
                          addNewClass({
                            name: classModelName,
                            category: category,
                            classes: classes,
                          });
                        }
                      "
                      block
                    >
                      <v-icon>{{ mdiPlus }}</v-icon>
                      <p class="ma-0 pa-0 ml-2">Adicionar nova classe</p>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" class="ma-0 pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  @click="activateTableMangement()"
                  :disabled="
                    (drugTab == 1 && !dose) || (drugTab == 3 && !product)
                  "
                  color="primary"
                  class="text-none"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>{{ mdiTableLarge }}</v-icon>
                </v-btn>
              </template>
              <span>Gestão de Tabelas</span>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="ma-0 pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  @click="editionDialogModel = true"
                  :disabled="!!dose || !!product"
                  color="primary"
                  class="text-none"
                  v-bind="attrs"
                  v-on="on"
                  :loading="!drugsSummary"
                >
                  <v-icon>{{ mdiPencil }}</v-icon>
                </v-btn>
              </template>
              <span>Seleção de itens para edição</span>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="ma-0 pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  @click="saveChanges()"
                  :disabled="!!dose || !!product"
                  color="primary"
                  class="text-none"
                  v-bind="attrs"
                  v-on="on"
                  :loading="!drugsSummary"
                >
                  <v-icon>{{ mdiContentSave }}</v-icon>
                </v-btn>
              </template>
              <span>Salvar alterações</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-divider class="mt-4"></v-divider>
        <v-row
          align="center"
          align-content="center"
          justify="start"
          class="pa-0 ma-0 pt-4 mt-2"
          v-show="!archiveMode"
        >
          <v-col cols="4" class="pa-0 ma-0 pl-2">
            <v-select
              v-if="!dose && !product"
              v-model="category"
              :items="categories"
              item-text="portugueseName"
              return-object
              label="Categoria"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0 pl-2" v-if="!dose && !product">
            <v-text-field
              outlined
              dense
              v-model="name"
              label="Nome"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0 pl-2" v-if="!dose && !product">
            <v-text-field
              outlined
              dense
              v-model="description"
              label="Descrição"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0 pl-2">
            <v-row class="ma-0 pa-0" justify="end">
              <v-select
                v-if="!dose && !product"
                v-model="tab"
                item-text="name"
                return-object
                :items="getTabs"
                label="Seção"
                dense
                outlined
              >
              </v-select>
            </v-row>
          </v-col>

          <v-col v-if="product" class="ma-0 pa=0" cols="6">
            <v-file-input
              accept="image/png,image/jpeg"
              label="Imagens do Produto"
              v-model="productImage"
              outlined
              dense
              :rules="rules"
            ></v-file-input>
          </v-col>
          <v-col :cols="product ? 6 : 4" class="pa-0 ma-0 pl-2">
            <v-select
              v-if="!dose"
              multiple
              v-model="itemClasses"
              :items="classesByCategory"
              item-text="name"
              return-object
              label="Classes"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="!dose && !product" cols="4" class="ma-0 pa-0 pl-2">
            <v-checkbox
              v-model="disabled"
              outlined
              :label="`Desabilitar visão da droga? ${disabled ? 'Sim' : 'Não'}`"
              class="ma-0 pa-0"
            ></v-checkbox>
          </v-col>
          <v-col cols="4" class="pa-0 ma-0 pl-2">
            <v-btn
              :disabled="!dose && !product"
              block
              class="primary"
              @click="backToDrugView()"
            >
              Voltar
            </v-btn>
          </v-col>
          <v-col cols="4" class="pa-0 ma-0 pl-2">
            <v-btn
              :disabled="!dose && drugTab != 0"
              block
              @click="addEvidence()"
              color="primary"
            >
              <v-icon class="mr-2">{{ mdiPlus }}</v-icon
              >Evidência
            </v-btn>
          </v-col>
          <v-col cols="4" class="pa-0 ma-0 pl-2">
            <v-btn block @click="removeSection()" color="error">
              <v-icon>{{ mdiClose }}</v-icon>
              Excluir último
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="mt-5"></v-divider>
        <v-row
          align="center"
          align-content="center"
          justify="start"
          class="pa-0 ma-0 pt-2"
          v-show="!archiveMode"
        >
          <v-col
            cols="3"
            class="pa-0 ma-0 pl-2"
            v-if="
              drugTab == 0 ||
              drugTab == 2 ||
              (dose && drugTab == 1) ||
              (product && drugTab == 3)
            "
          >
            <v-combobox
              v-model="sectionType"
              :items="sectionTypes"
              label="Tópico"
              dense
              outlined
            ></v-combobox>
          </v-col>
          <v-col
            v-show="
              drugTab == 0 ||
              drugTab == 2 ||
              (dose && drugTab == 1) ||
              (product && drugTab == 3)
            "
            :cols="sectionType == 'Título' ? 5 : 7"
            class="pa-0 ma-0 pl-2"
          >
            <v-text-field
              outlined
              dense
              v-model="sectionText"
              label="Descrição do tópico"
            ></v-text-field>
          </v-col>
          <v-col
            v-show="
              (drugTab == 0 ||
                drugTab == 2 ||
                (dose && drugTab == 1) ||
                (product && drugTab == 3)) &&
              sectionType == 'Título'
            "
            cols="2"
            align-self="start"
            class="ma-0 pa-0 pl-2"
          >
            <v-checkbox
              v-model="collapse"
              class="ma-0 pa-0 pt-2"
              :label="`Colapsar: ${collapse ? 'Sim' : 'Não'}`"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="1"
            class="ma-0 pa-0 pl-2"
            align-self="start"
            v-show="
              drugTab == 0 ||
              drugTab == 2 ||
              (dose && drugTab == 1) ||
              (product && drugTab == 3)
            "
          >
            <v-btn @click="addSection()" dark color="primary">
              <v-icon>{{ mdiPlus }}</v-icon>
            </v-btn>
          </v-col>
          <v-col v-if="product" class="ma-0 pa=0" cols="12">
            <p v-for="photo in photos" :key="photo.name">
              {{ photo.name }}
              <v-icon style="cursor: pointer" @click="removePhoto(photo.name)">
                {{ mdiClose }}
              </v-icon>
            </p>
          </v-col>
          <v-col
            cols="6"
            class="ma-0 pa-0 pl-2"
            v-show="drugTab == 1 && !dose && ![11, 14].includes(category.id)"
          >
            <v-text-field
              dense
              outlined
              v-model="new_dose.title"
              label="Título"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0 pl-2" v-show="drugTab == 1 && !dose">
            <v-text-field
              v-if="![11, 14].includes(category.id)"
              dense
              outlined
              v-model="new_dose.dose"
              label="Dose"
            ></v-text-field>

            <v-select
              v-else
              v-model="new_dose.dose"
              :items="otherAnimalsList"
              label="Animais do Item"
              dense
              outlined
              clearable
              multiple
            ></v-select>
          </v-col>
          <v-col
            cols="6"
            class="ma-0 pa-0 pl-2"
            v-show="drugTab == 1 && !dose && ![11, 14].includes(category.id)"
          >
            <v-text-field
              dense
              outlined
              v-model="new_dose.measurement"
              label="Medida"
            ></v-text-field>
          </v-col>
          <v-col
            cols="6"
            class="ma-0 pa-0 pl-2"
            v-show="drugTab == 1 && !dose && ![11, 14].includes(category.id)"
          >
            <v-text-field
              dense
              outlined
              v-model="new_dose.description"
              label="Descrição"
            ></v-text-field>
          </v-col>
          <v-col
            cols="6"
            class="ma-0 pa-0 pl-2"
            v-show="drugTab == 1 && !dose && ![11, 14].includes(category.id)"
          >
            <v-combobox
              v-model="new_dose.animals"
              :items="[
                { value: 1, text: 'Cães' },
                { value: 2, text: 'Gatos' },
              ]"
              label="Animais"
              dense
              outlined
              clearable
              multiple
            ></v-combobox>
          </v-col>
          <v-col
            cols="6"
            class="ma-0 pa-0 pb-5 pl-2"
            v-show="drugTab == 1 && !dose"
          >
            <v-btn block @click="addDose()" color="primary" class="text-none">
              <v-icon>{{ mdiPlus }}</v-icon>
              Adicionar dose
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          align="center"
          align-content="center"
          justify="start"
          class="pa-0 ma-0 mt-5"
          v-show="!archiveMode"
        >
          <v-col cols="4" v-show="drugTab == 3 && !product">
            <v-combobox
              v-model="product_type"
              :items="productTypes"
              label="Tipo do produto"
              dense
              outlined
            ></v-combobox>
          </v-col>
          <v-col
            cols="4"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-text-field
              v-model="new_product.name"
              label="Nome do Produto *"
              hint="Começando com letra maiúscula"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col
            cols="4"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-select
              v-model="new_product.animals"
              :items="[
                { value: 1, text: 'Cães' },
                { value: 2, text: 'Gatos' },
              ]"
              return-object
              item-text="text"
              label="Animais permitidos"
              dense
              multiple
              outlined
              clearable
            ></v-select>
          </v-col>

          <v-col
            cols="4"
            v-show="drugTab == 3 && !product && product_type.value == 2"
          >
            <v-combobox
              v-model="humanProductsNames"
              hide-selected
              label="Nomes dos produtos humanos"
              multiple
              persistent-hint
              dense
              outlined
              small-chips
              clearable
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Digite os nomes (começando com letra maíuscula) e aperte
                      enter para inseri-los na lista</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
          <v-col cols="4" v-show="drugTab == 3 && !product">
            <v-text-field
              v-model="new_product.brand"
              label="Marca *"
              dense
              outlined
              hint="Começando com letra maiúscula"
            ></v-text-field>
          </v-col>
          <v-col
            cols="4"
            v-if="category.foods"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-combobox
              v-model="new_product.brandLines"
              hide-selected
              label="Linhas do produto"
              multiple
              clearable
              dense
              outlined
              persistent-hint
              small-chips
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Digite uma linha sem espaços em volta e aperte enter para
                      inseri-lo na lista.</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
          <v-col
            cols="4"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-select
              v-if="category.foods"
              dense
              outlined
              clearable
              v-model="new_product.presentation"
              chips
              label="Apresentação do Alimento *"
              :items="['Seco', 'Úmido']"
            ></v-select>
            <v-text-field
              v-else
              dense
              outlined
              v-model="new_product.presentation"
              label="Apresentação *"
              hint="Começando com letra maiúscula.  Use ; para separar vários termos."
            ></v-text-field>
          </v-col>
          <v-col
            cols="4"
            v-if="category.foods"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-select
              v-model="new_product.petSizes"
              chips
              dense
              outlined
              clearable
              multiple
              label="Porte do Paciente"
              :items="['Mini', 'Pequeno', 'Médio', 'Grande', 'Gigante']"
            ></v-select>
          </v-col>
          <v-col
            cols="4"
            v-if="category.foods"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-select
              v-model="new_product.petAges"
              chips
              dense
              multiple
              clearable
              outlined
              label="Idade do Paciente"
              :items="['Neonato', 'Filhote', 'Adulto', 'Sênior']"
            ></v-select>
          </v-col>
          <v-col
            cols="4"
            v-if="category.foods"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-select
              v-model="new_product.petBreeds"
              chips
              dense
              outlined
              multiple
              clearable
              label="Raça do Paciente"
              :items="[
                'Shih Tzu',
                'Maltês',
                'Yorkshire',
                'Bulldog Francês',
                'Bulldog Inglês',
                'Golden Retriever',
                'Labrador Retriever',
                'Lhasa Apso',
                'Pug',
                'Schnauzer',
                'Dachshund',
                'Rottweiler',
                'Spitz Alemão | Lulu da Pomerânia',
                'Pastor Alemão',
                'Pit Bull',
                'Poodle',
                'Sharpei',
                'Boxer',
                'Persa',
                'Maine Coon',
              ]"
            ></v-select>
          </v-col>
          <v-col
            cols="6"
            v-if="category.foods"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-select
              v-model="new_product.features"
              chips
              dense
              outlined
              clearable
              multiple
              label="Características do Alimento"
              :items="[
                'Ambiente Interno',
                'Grain Free',
                'Econômica | Standard',
                'Premium',
                'Premium Especial',
                'Super Premium',
                'Pacientes Castrados',
                'Sem Transgênicos',
                'Natural',
                'Orgânico',
                'Proteína de Peixes',
                'Light',
                'Suporte Lácteo | Aleitamento Artificial',
              ]"
            ></v-select>
          </v-col>
          <v-col
            cols="6"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-combobox
              v-model="new_product.volumes"
              hide-selected
              label="Volumes"
              multiple
              clearable
              dense
              outlined
              persistent-hint
              small-chips
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Digite volumes sem espaços e aperte enter para inseri-los
                      na lista. Use ; para separar R$ em alimentos (ex:
                      50mg;R$10,00)</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
          <v-col cols="6" v-show="drugTab == 3 && !product && !category.foods">
            <v-combobox
              v-model="new_product.drugs"
              hide-selected
              label="Princípios Ativos"
              multiple
              persistent-hint
              dense
              outlined
              clearable
              small-chips
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Digite os princípios ativos (começando com letra
                      maíuscula) e aperte enter para inseri-los na lista (ex:
                      Acarbose)</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
          <v-col
            cols="6"
            v-show="drugTab == 3 && !product && product_type.value == 2"
          >
            <v-text-field
              v-model="presentation"
              dense
              outlined
              label="Apresentação"
              hint="Ex: Solução Oral."
            ></v-text-field>
          </v-col>
          <v-col
            cols="6"
            v-show="drugTab == 3 && !product && product_type.value == 2"
          >
            <v-text-field
              v-model="volume"
              outlined
              dense
              label="Volume"
              hint="Ex: 50mg/ml"
            ></v-text-field>
          </v-col>
          <v-col
            cols="1"
            v-show="drugTab == 3 && !product && product_type.value == 2"
          >
            <v-btn
              block
              @click="addPresentationVolume()"
              icon
              dark
              color="primary"
              class="mx-2"
            >
              <v-icon class="mr-2">{{ mdiPlus }}</v-icon>
            </v-btn>
          </v-col>
          <v-col
            cols="5"
            v-show="drugTab == 3 && !product && product_type.value == 2"
          >
            <p class="pa-0 ma-0 title">Apresentações - Volumes:</p>
            <div
              class="pa-0 ma-0"
              v-for="presentation_volume in new_product.presentation_volumes"
              :key="
                presentation_volume.presentation + presentation_volume.volume
              "
            >
              <p class="pa-0 ma-0">
                {{
                  presentation_volume.presentation +
                  " - " +
                  presentation_volume.volume
                }}
              </p>
            </div>
          </v-col>

          <v-col
            cols="6"
            v-show="drugTab == 3 && !product && product_type.value == 2"
          >
            <v-btn
              block
              @click="addHumProduct()"
              color="primary"
              class="text-none"
            >
              <v-icon class="mr-2">{{ mdiPlus }}</v-icon
              >Adicionar produto humano
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            v-show="drugTab == 3 && !product && product_type.value == 1"
          >
            <v-btn
              block
              @click="addVetProduct()"
              color="primary"
              class="text-none mb-5"
            >
              <v-icon class="mr-2">{{ mdiPlus }}</v-icon
              >Adicionar produto veterinário
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-show="archiveMode" class="ma-0 pa-0 mt-5">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" align="center" justify="end">
              <v-btn
                @click="commitArchiveMode()"
                class="primary white--text mr-4 text-none"
                >Pré visualizar alterações</v-btn
              >
              <v-btn
                @click="cancelArchiveMode()"
                class="error white--text mr-4 text-none"
                >Cancelar sem salvar</v-btn
              >
              <v-btn
                class="success white--text text-none"
                @click="saveArchiveMode()"
                >Salvar alterações do arquivo</v-btn
              >
            </v-row>
          </v-col>
          <v-col cols="12" class="ma-0 pa-0 mt-4">
            <div id="jsoneditor" style="width: 100%; height: 100%"></div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="5" class="pa-0 ma-0 mt-5 pr-5 pb-5">
      <v-card
        elevation="5"
        class="ma-0 pa-0 white"
        style="overflow-y: auto !important"
        :max-width="_getMaxWidth()"
        height="700px"
      >
        <v-container>
          <Drugs v-if="!dose && !product" :isDrugsManagement="true"></Drugs>
          <Doses v-if="dose && !product" :isDrugsManagement="true"></Doses>
          <Products
            v-if="!dose && product"
            :isDrugsManagement="true"
          ></Products>
        </v-container>
      </v-card>
    </v-col>
    <TableManagement></TableManagement>
    <v-dialog persistent v-model="editionDialogModel" max-width="700px">
      <v-card height="500px" max-width="700px" class="white pa-0 ma-0">
        <v-card-title class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 mt-3" justify="start">
            <v-col cols="3" class="ma-0 pa-0">
              <v-row class="ma-0 pa-0" justify="start" align="center">
                <v-btn
                  @click="editionDialogModel = false"
                  text
                  class="text-none primary--text"
                  >{{ labels.CLOSE }}
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="6" class="ma-0 pa-0">
              <v-row
                justify="center"
                align="center"
                class="vetalfa-row ma-0 pa-0 px-4"
              >
                <p class="text-center vetalfa-dialog-title pt-1 pa-0 ma-0">
                  Edição de Itens
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="ma-0 pa-0 py-4">
          <vetalfa-section-title
            prop="Selecione a droga que deseja editar/deletar"
            class="ma-0 pa-0 mt-5"
          >
            <v-row class="ma-0 pa-0 px-4">
              <v-checkbox
                class="pt-5 ma-0 pa-0"
                v-model="temp"
                v-if="
                  summaryTemp[category.collection] &&
                  summaryTemp[category.collection].length
                "
                :label="`Continuar cadastro temporário? ${
                  temp ? 'Sim' : 'Não'
                }`"
              ></v-checkbox>
            </v-row>
            <v-row class="ma-0 pa-0 px-4">
              <v-combobox
                :label="editionDrug ? '' : 'Selecione'"
                class="pt-2"
                chips
                dense
                v-if="drugsSummary && summaryTemp"
                :items="summary"
                item-text="name"
                outlined
                clearable
                v-model="editionDrug"
              ></v-combobox>
            </v-row>
            <v-row class="ma-0 pa-0 px-4">
              <v-btn
                :disabled="!editionDrug"
                block
                color="primary"
                class="mt-5 text-none"
                @click="
                  () => {
                    selectEditionDrug();
                    editionDialogModel = false;
                  }
                "
                >Selecionar item</v-btn
              >
            </v-row>
            <v-row v-if="!temp" class="ma-0 pa-0 px-4 pt-5 mt-5">
              <v-col class="ma-0 pa-0" cols="8">
                <v-checkbox
                  class="pt-5 ma-0 pa-0"
                  v-model="productExclusion"
                  :disabled="!editionDrug"
                  :label="`Apagar produtos? ${temp ? 'Sim' : 'Não'}`"
                ></v-checkbox>
                <v-checkbox
                  class="ma-0 pa-0"
                  v-model="tempExclusion"
                  :disabled="!editionDrug"
                  :label="`Apagar versões temporárias?? ${
                    tempExclusion ? 'Sim' : 'Não'
                  }`"
                ></v-checkbox>
              </v-col>
              <v-col class="ma-0 pa-0" cols="4">
                <v-row align="end" class="ma-0 pa-0" style="height: 100%">
                  <v-btn
                    :disabled="!editionDrug"
                    block
                    color="red"
                    class="mt-5 text-none white--text"
                    @click="
                      () => {
                        editionDialogModel = false;
                        deleteDrug({
                          id: editionDrug.id,
                          category,
                          tempExclusion,
                          productExclusion,
                        });
                      }
                    "
                    >Excluir item</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </vetalfa-section-title>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style>
@import "../../node_modules/jsoneditor/dist/jsoneditor.min.css";
.drugs-management {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: 100%;
  width: 100%;
  border-radius: 0px;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  mdiContentSave,
  mdiEye,
  mdiPlus,
  mdiClose,
  mdiPencil,
  mdiFile,
  mdiFilterVariant,
  mdiTableLarge,
} from "@mdi/js";
import enums from "@/constants/enums.js";
import Drugs from "@/views/Drugs.vue";
import Doses from "@/views/Doses.vue";
import Products from "@/views/Products.vue";
import TableManagement from "@/components/management/TableManagement.vue";
import JSONEditor from "jsoneditor";
import categories from "@/constants/categories.js";
import labels from "@/constants/labels.js";
export default {
  name: "DrugsManagement",
  methods: {
    ...mapActions("drugs", ["getSummary"]),
    ...mapActions("management", [
      "getItemWithIdForManagement",
      "deleteSelectedClass",
      "addNewClass",
      "loginManagement",
      "saveItemAndProducts",
      "insertPhoto",
      "setTable",
      "getClasses",
      "deleteDrug",
    ]),
    ...mapMutations("drugs", [
      "setDrugTab",
      "setDrug",
      "setVeterinaryProductsMap",
      "setHumanProductsMap",
      "setProduct",
      "setDose",
    ]),
    ...mapMutations("general", [
      "setIsDrugsManagement",
      "setLoadingOn",
      "setLoadingOff",
    ]),
    ...mapMutations("management", [
      "setTableModal",
      "setSelectedSection",
      "setTable",
      "setFinalTable",
    ]),
    backToDrugView() {
      this.setDose(null);
      this.saveProductClassesAndPhotos();
      this.setProduct(null);
    },
    activateTableMangement() {
      this.commitChanges();
      this.setSelectedSection(this.tab);
      this.setTableModal(true);
    },
    removePhoto(name) {
      this.photos = this._removeFromArrayWithName(this.photos, name);
    },
    saveProductClassesAndPhotos() {
      this.product["classes"] = this.itemClasses;
      this.itemClasses = this.drug.classes;
      this.product["photos"] = [];
      this.photos.forEach((p) => {
        this.product.photos.push(p);
      });
      this.photos = [];
      this.veterinary_products.forEach((v) => {
        if (v.name == this.product.name) {
          v = this.product;
        }
      });
      this.commitChanges();
    },
    selectEditionDrug() {
      this.resetProduct();
      this.getItemWithIdForManagement({
        id: this.editionDrug.id,
        temp: this.temp,
        collection: this.category.collection,
        productsCollection: this.category.productsCollection,
      });
    },
    commitArchiveMode() {
      this.setDrug(this.archiveEditor.get());
      this.prepareDataForEdition();
    },
    saveArchiveMode() {
      this.commitArchiveMode();
      this.archiveMode = false;
      this.drugBeforeAchiveEdition = {};
    },
    cancelArchiveMode() {
      this.setDrug(Object.assign({}, this.drugBeforeAchiveEdition));
      this.prepareDataForEdition();
      this.archiveMode = false;
      this.drugBeforeAchiveEdition = {};
    },
    addEvidence() {
      var name = prompt("Digite o nome da evidência:");
      var year = prompt("Digite o ano da evidência:");
      var magazine = prompt("Digite a revista:");
      var level = prompt("Digite o grau de evidência de 1 a 5:");
      var link = prompt("Digite o link para o artigo:");
      if (name && year && magazine && level && link) {
        let evidence = {
          name: name,
          year: year,
          magazine: magazine,
          level: level,
          link: link,
        };
        if (this.drugTab == 0) {
          this.references.push(evidence);
        } else {
          if (!this.dose.references) {
            this.dose["references"] = [];
          }
          this.dose.references.push(evidence);
          this.doses[this.dose_index] = this.dose;
        }
        this.commitChanges();
        alert(
          "Evidência cadastrada com sucesso, para editar clique em + Evidência novamente."
        );
      } else {
        alert(
          "É necessário cadastrar todos os dados, clique em + Evidência para prosseguir com esta ação."
        );
      }
    },
    saveChanges() {
      if (
        confirm("Deseja finalizar o cadatro da nova droga e novos produtos?")
      ) {
        if (!this.name || !this.description) {
          alert("Preencha primeiro o nome e a descrição antes de prosseguir.");
          return;
        }
        this.commitChanges();

        var finalDrug = Object.assign({}, this.drug);

        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," +
            encodeURIComponent(JSON.stringify(finalDrug))
        );
        element.setAttribute("download", this.name);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setDrug(null);
        this.setProduct(null);
        this.saveItemAndProducts(finalDrug);
        this.updateCategorySummaryList(this.category.collection);
      }
    },
    prepareDataForEdition() {
      this.editionDialogModel = false;
      this.editionDrug = null;
      this.name = this.drug.name;
      this.description = this.drug.description;
      this.info = this.drug.info;
      this.attention = this.drug.attention;
      this.doses = this.drug.doses;
      this.veterinary_products = this.drug.veterinary_products;
      this.human_products = this.drug.human_products;
      this.references = this.drug.references;
      this.itemClasses = this.drug.classes || [];
      this.disabled = this.drug.disabled;
      this.commitChanges();
    },
    commitChanges() {
      this.veterinary_products.forEach((v) => {
        v["category"] = this.category;
      });
      var new_drug = {
        name: this.name,
        description: this.description,
        id: this._createIdentifier(this.name.toLowerCase()),
        info: this.info,
        attention: this.attention,
        doses: this.doses,
        veterinary_products: this.veterinary_products,
        human_products: this.human_products,
        version: 1,
        references: this.references,
        category: this.category,
        vaccines_suplements_serums: this.category.vaccines_suplements_serums,
        classes: [],
        disabled: this.disabled,
      };
      this.itemClasses.forEach((i) => {
        new_drug.classes.push(i);
      });

      if (
        new TextEncoder().encode(JSON.stringify(new_drug)).length / 1024 >
        600
      ) {
        alert(
          "Seu cadastro está superando o limite de 1MB, salve para garantir que seus dados vão ser salvos corretamente!"
        );
      }

      this.setDrug(new_drug);
      var map = {};
      this.veterinary_products.forEach((product) => {
        if (!map[product.presentation.trim()]) {
          map[product.presentation.trim()] = [];
        }
        map[product.presentation.trim()].push(product);
      });
      this.setVeterinaryProductsMap(map);
      map = {};
      this.human_products.forEach((product) => {
        product.presentation_volumes.forEach((pv) => {
          if (!map[pv.presentation.trim()]) {
            map[pv.presentation.trim()] = {};
            map[pv.presentation.trim()]["presentation"] =
              pv.presentation.trim();
          }
          if (!map[pv.presentation.trim()][pv.volume.trim()]) {
            map[pv.presentation.trim()][pv.volume.trim()] = {};
            map[pv.presentation.trim()][pv.volume.trim()]["volume"] =
              pv.volume.trim();
            map[pv.presentation.trim()][pv.volume.trim()]["products"] = [];
          }
          map[pv.presentation.trim()][pv.volume.trim()]["products"].push(
            product.name.trim()
          );
        });
      });
      this.setHumanProductsMap(map);
    },
    addDose() {
      if (
        (!this.new_dose.animals.length &&
          ![11, 14].includes(this.category.id)) ||
        ([11, 14].includes(this.category.id) && !this.new_dose.dose.length)
      ) {
        alert("Selecione um animal correto.");
        return;
      } else if (
        ![11, 14].includes(this.category.id) &&
        (!this.new_dose.title || !this.new_dose.dose)
      ) {
        alert("Os campos Título e Dose são obrigatórios.");
        return;
      }
      let animals = [];
      this.new_dose.animals.forEach((animal) => {
        animals.push(animal.value);
      });
      this.doses.push({
        title: this.new_dose.title,
        description: this.new_dose.description,
        dose:
          typeof this.new_dose.dose == "string"
            ? this.new_dose.dose
            : this.new_dose.dose.toString().replaceAll(",", " | "),
        animals: animals,
        measurement: this.new_dose.measurement,
        sections: [],
      });
      this.commitChanges();
      this.new_dose = {
        title: "",
        description: "",
        dose: "",
        animals: [],
        measurement: "",
        sections: [],
      };
    },
    addSectionProductPhoto(photo) {
      this.product.sections.push({ photo });
      this.veterinary_products.forEach((vet_product) => {
        if (vet_product.name == this.product.name) {
          vet_product.sections = this.product.sections;
        }
      });
      this.commitChanges();
    },
    addSection() {
      if (!this.sectionText) {
        alert("O texto da seção é obrigatório");
        return;
      }
      var arr = [];
      switch (this.drugTab) {
        case 0:
          arr = this.info;
          break;
        case 1:
          arr = this.dose.sections;
          break;
        case 2:
          arr = this.attention;
          break;
        case 3:
          arr = this.product.sections;
          break;
      }

      if (this.sectionType == this.sectionTypes[0]) {
        let obj = {
          description: this.sectionText,
          objects: [],
        };
        if (this.collapse && !this.dose) {
          obj["collapse"] = this.collapse;
        }
        arr.push(obj);
      } else if (this.sectionType == this.sectionTypes[1]) {
        try {
          let objects = arr[arr.length - 1].objects;
          objects.push({
            description: this.sectionText,
            objects: [],
          });
        } catch {
          alert("Adicione uma seção superior antes de adicionar outras seções");
        }
      } else if (this.sectionType == this.sectionTypes[2]) {
        try {
          let sectionTitle = arr[arr.length - 1].objects;
          if (!sectionTitle.length) {
            sectionTitle.push({ objects: [] });
          }
          let objects = sectionTitle[sectionTitle.length - 1].objects;
          objects.push({
            description: this.sectionText,
            objects: [],
          });
        } catch {
          alert("Adicione um título antes de adicionar outras seções");
        }
      } else if (this.sectionType == this.sectionTypes[3] && !this.dose) {
        try {
          let section = arr[arr.length - 1].objects;
          let items = section[section.length - 1].objects;
          let objects = items[items.length - 1].objects;
          objects.push({
            description: this.sectionText,
          });
        } catch {
          alert("Adicione um título e  um item antes de adicionar um sub item");
        }
      } else if (this.sectionType == this.sectionTypes[4]) {
        try {
          let title = arr[arr.length - 1];
          if (!title.paragraphs) {
            title["paragraphs"] = [];
          }
          if (title.objects) {
            delete title["objects"];
          }
          title.paragraphs.push(this.sectionText);
        } catch {
          alert("Adicione um título antes de adicionar um paragráfo");
        }
      }
      switch (this.drugTab) {
        case 0:
          this.info = arr;
          break;
        case 1:
          this.doses[this.dose_index].sections = arr;
          this.dose.sections = arr;
          break;
        case 2:
          this.attention = arr;
          break;
        case 3:
          this.product.sections = arr;
          this.veterinary_products.forEach((vet_product) => {
            if (vet_product.name == this.product.name) {
              vet_product.sections = arr;
            }
          });
          break;
      }
      this.commitChanges();
    },
    removeSection() {
      var arr = [];
      if (this.drugTab == 1 && !this.dose) {
        this.doses.pop();
      } else if (this.drugTab == 3 && !this.product) {
        var r = confirm(
          "Você deseja excluir um medicamento veterinário? Aperta OK para confirmar ou cancelar para excluir um medicamento Humano."
        );
        if (r) {
          this.veterinary_products.pop();
        } else {
          this.human_products.pop();
        }
      } else {
        switch (this.drugTab) {
          case 0:
            arr = this.info;
            break;
          case 1:
            arr = this.dose.sections;
            break;
          case 2:
            arr = this.attention;
            break;
          case 3:
            arr = this.product.sections;
            break;
        }
        if (this._isNotEmpty(arr[arr.length - 1].objects)) {
          let section = arr[arr.length - 1].objects;
          if (this._isNotEmpty(section[section.length - 1].objects)) {
            let item = section[section.length - 1].objects;
            if (this._isNotEmpty(item[item.length - 1].objects)) {
              item[item.length - 1].objects.pop();
            } else {
              item.pop();
            }
          } else {
            section.pop();
          }
        } else if (this._isNotEmpty(arr[arr.length - 1].paragraphs)) {
          arr[arr.length - 1].paragraphs.pop();
        } else {
          arr.pop();
        }
        switch (this.drugTab) {
          case 0:
            this.info = arr;
            break;
          case 1:
            this.doses[this.dose_index].sections = arr;
            break;
          case 2:
            this.attention = arr;
            break;
          case 3:
            this.product.sections = arr;
            this.veterinary_products.forEach((vet_product) => {
              if (vet_product.name == this.product.name) {
                vet_product.sections = arr;
              }
            });
            break;
        }
      }
      this.commitChanges();
    },
    addVetProduct() {
      if (
        !this.new_product.brand ||
        !this.new_product.name ||
        !this.new_product.presentation
      ) {
        alert("Preencha todos os campos antes de prosseguir");
        return;
      }
      let animals = [];
      this.new_product.animals.forEach((animal) => {
        animals.push(animal.value);
      });
      let product_drugs = [];
      this.new_product.drugs.forEach((drug) => {
        product_drugs.push({
          id: this._createIdentifier(drug.replace(/ /g, "").toLowerCase()),
          name: drug,
        });
      });
      let newObj = {
        animals: animals,
        brand: this.new_product.brand,
        id: this._createIdentifier(
          this.new_product.name.replace(/ /g, "").toLowerCase()
        ),
        name: this.new_product.name,
        presentation: this.new_product.presentation,
        volumes: this.new_product.volumes,
        drugs: product_drugs,
        sections: [],
        version: 1,
      };
      if (this.category.foods) {
        newObj["drugs"] = [];
        newObj["petSizes"] = this.new_product["petSizes"];
        newObj["petAges"] = this.new_product["petAges"];
        newObj["petBreeds"] = this.new_product["petBreeds"];
        newObj["features"] = this.new_product["features"];
        newObj["brandLines"] = this.new_product["brandLines"];
      }
      this.veterinary_products.push(newObj);
      this.resetProduct();
      this.commitChanges();
    },
    addHumProduct() {
      if (!this.new_product.presentation_volumes.length) {
        alert("Preencha as apresentações e volumes deste medicamento");
        return;
      }
      if (!this.humanProductsNames.length) {
        this.humanProductsNames.push("");
      }
      this.humanProductsNames.forEach((name) => {
        this.new_product.brand = this.new_product.brand || "none";
        this.new_product.name = name || "generic" + this._getTimestamp();
        let product_drugs = [];
        this.new_product.drugs.forEach((drug) => {
          product_drugs.push({
            id: this._createIdentifier(drug.replace(/ /g, "").toLowerCase()),
            name: drug,
          });
        });
        this.human_products.push({
          brand: this.new_product.brand,
          id: this._createIdentifier(
            this.new_product.name.replace(/ /g, "").toLowerCase()
          ),
          name: this.new_product.name,
          presentation_volumes: this.new_product.presentation_volumes,
          drugs: product_drugs,
          version: 1,
        });
      });
      this.resetProduct();
      this.commitChanges();
    },
    resetProduct() {
      this.new_product = {
        animals: [],
        brand: "",
        brandLines: [],
        id: "",
        name: "",
        presentation: "",
        volumes: [],
        presentation_volumes: [],
        drugs: [],
        petSizes: [],
        petAges: [],
        petBreeds: [],
        features: [],
      };
      this.humanProductsName = [];
    },
    addPresentationVolume() {
      this.new_product.presentation_volumes.push({
        presentation: this.presentation,
        volume: this.volume,
      });
      this.volume = "";
    },
    updateCategorySummaryList: async function (collection) {
      this.setLoadingOn();
      await this.getSummary({ collection: collection, temp: true });
      this.setLoadingOff();
    },
  },
  computed: {
    ...mapGetters("drugs", [
      "drugsSummary",
      "summaryTemp",
      "drugTab",
      "productsSummary",
      "drug",
      "dose",
      "dose_index",
      "product",
      "classes",
    ]),
    otherAnimalsList() {
      return !!this.category && this.category.id == 11
        ? [
            "Roedores",
            "Rato",
            "Chinchila",
            "Porquinho-da-índia",
            "Hamster",
            "Ferret",
            "Coelho",
            "Aves",
            "Psitacídeos",
            "Passeriformes",
            "Galliformes",
            "Répteis",
            "Lagartos",
            "Serpentes",
            "Testudines",
            "Jabuti",
            "Cágado",
            "Mini Porco",
            "Anfíbios",
            "Peixes",
            "Gerbil",
            "Hedgehog",
          ]
        : ["Equinos", "Bovinos", "Ovinos", "Caprinos", "Suínos"];
    },
    ...mapGetters("management", ["managementToken", "finalTable", "profile"]),
    isDevelopment() {
      return process.env.NODE_ENV == "development";
    },
    categories() {
      return categories.filter((c) => {
        return (
          this.profile == 1 || this.isDevelopment || [11, 14].includes(c.id)
        );
      });
    },
    summary() {
      let arr = [];
      this._sortByProp(
        this.temp
          ? this.summaryTemp[this.category.collection]
          : this.drugsSummary[this.category.collection],
        "name"
      ).forEach((s) => {
        delete s.disabled;
        arr.push(s);
      });
      return arr;
    },
    sectionTypes() {
      if (this.dose) {
        return ["Seção", "Item", "Sub Item"];
      }
      return ["Título", "Seção", "Item", "Sub Item", "Paragráfo"];
    },
    classesByCategory() {
      let arr = [];
      this.classes.forEach((c) => {
        if (c.category.id == this.category.id) {
          arr.push(c.name);
        }
      });
      return arr;
    },
    productTypes() {
      let types = [{ value: 1, text: "Veterinário" }];
      if (this.category.human_products) {
        types.push({ value: 2, text: "Humano" });
      }
      return types;
    },
    getTabs() {
      let arr = [];
      let index = 0;
      enums.DRUGS_TABS.forEach((tab) => {
        if (tab.products || !this.category.vaccines_suplements_serums) {
          arr.push({ name: tab.name, index: index });
        }
        index++;
      });
      return arr;
    },
    tab: {
      get() {
        return this.getTabs[this.drugTab];
      },
      set(tab) {
        this.setDrugTab(tab.index);
      },
    },
  },
  watch: {
    productImage: async function (val) {
      if (val) {
        const addToSection = confirm(
          "Adicionar foto ao corpo do produto? Clique em OK para confirmar ou cancele."
        );
        const photoName = this._getTimestamp() + this.product.name + val.name;
        const photoUrl = await this.insertPhoto({
          type: val.type,
          name: photoName,
          file: val,
        });
        const newPhoto = { name: photoName, src: photoUrl };
        if (addToSection) {
          this.addSectionProductPhoto(newPhoto);
        } else {
          this.photos.push(newPhoto);
        }
        this.productImage = null;
      }
    },
    category(val) {
      this.itemClasses = [];
      this.updateCategorySummaryList(val.collection);
      this.commitChanges();
    },
    name() {
      this.commitChanges();
    },
    product(val) {
      if (val) {
        this.commitChanges();
        this.itemClasses = val.classes || [];
        this.photos = val.photos || [];
      }
    },
    description() {
      this.commitChanges();
    },
    product_type() {
      this.resetProduct();
    },
    drug() {
      if (this.editionDrug) {
        this.prepareDataForEdition();
      }
    },
    archiveMode(val) {
      if (val) {
        this.commitChanges();
        const container = document.getElementById("jsoneditor");
        const options = {};
        if (!this.archiveEditor) {
          this.archiveEditor = new JSONEditor(container, options);
        }
        const editJson = Object.assign({}, this.drug);
        this.drugBeforeAchiveEdition = Object.assign({}, this.drug);
        this.archiveEditor.set(editJson);
      }
    },
    classesModelManagement(val) {
      if (!val) {
        this.classModel = null;
        this.classModelName = null;
      }
    },
    finalTable(val) {
      if (val) {
        var arr = [];
        switch (this.drugTab) {
          case 0:
            arr = this.info;
            break;
          case 1:
            arr = this.dose.sections;
            break;
          case 2:
            arr = this.attention;
            break;
          case 3:
            arr = this.product.sections;
            break;
        }
        if (arr.length) {
          var sections = arr[arr.length - 1].objects;
          if (sections && sections.length) {
            var items = sections[sections.length - 1].objects;
            if (items.length) {
              var subItems = items[items.length - 1].objects;
              if (subItems.length) {
                subItems[subItems.length - 1]["table"] = {
                  headers: val.headers,
                  lines: val.lines,
                  caption: val.caption,
                };
              } else {
                items[items.length - 1]["table"] = {
                  headers: val.headers,
                  lines: val.lines,
                  caption: val.caption,
                };
              }
            } else {
              sections[sections.length - 1]["table"] = {
                headers: val.headers,
                lines: val.lines,
                caption: val.caption,
              };
            }
          } else {
            arr[arr.length - 1]["table"] = {
              headers: val.headers,
              lines: val.lines,
              caption: val.caption,
            };
          }
        } else {
          alert("Crie uma seção antes de adicionar uma tabela");
          return;
        }
        switch (this.drugTab) {
          case 0:
            this.info = arr;
            break;
          case 1:
            this.doses[this.dose_index].sections = arr;
            this.dose.sections = arr;
            break;
          case 2:
            this.attention = arr;
            break;
          case 3:
            this.product.sections = arr;
            this.veterinary_products.forEach((vet_product) => {
              if (vet_product.name == this.product.name) {
                vet_product.sections = arr;
              }
            });
            break;
        }
        this.commitChanges();
        this.setTable(null);
        this.setFinalTable(null);
        this.setTableModal(false);
      }
    },
  },
  components: {
    Drugs,
    Doses,
    Products,
    TableManagement,
  },
  data() {
    return {
      rules: [
        (value) =>
          !value ||
          value.size < 5000000 ||
          "Arquivo não pode ser maior que 5MB!",
      ],
      labels,
      disabled: false,
      category: null,
      editionDrug: null,
      new_dose: {
        title: "",
        description: "",
        dose: "",
        animals: [],
        measurement: "",
        sections: [],
      },
      new_product: {
        animals: [],
        brand: "",
        brandLines: [],
        id: "",
        name: "",
        drugs: [],
        presentation: "",
        volumes: [],
        presentation_volumes: [],
        sections: [],
        petSizes: [],
        petAges: [],
        petBreeds: [],
        features: [],
      },
      presentation: "",
      volume: "",
      veterinary_products: [],
      human_products: [],
      mdiContentSave,
      mdiEye,
      mdiPlus,
      mdiClose,
      mdiPencil,
      mdiFile,
      mdiFilterVariant,
      mdiTableLarge,
      name: "",
      description: "",
      sectionType: "",
      sectionText: "",
      collapse: false,
      info: [],
      attention: [],
      doses: [],
      product_type: {
        value: 1,
        text: "Veterinário",
      },
      references: [],
      editionDialogModel: false,
      editionNotes: "",
      temp: false,
      archiveMode: false,
      archiveEditor: null,
      drugBeforeAchiveEdition: {},
      humanProductsNames: [],
      itemClasses: [],
      productClasses: [],
      classesModelManagement: false,
      classModel: null,
      classModelName: null,
      productImage: null,
      photos: [],
      tempExclusion: true,
      productExclusion: true,
    };
  },
  mounted: async function () {
    if (!this.isDevelopment) {
      await this.loginManagement();
    }
    await this.getClasses();
    this.$nextTick(() => {
      this.category = this.categories[0];
      this.setIsDrugsManagement(true);
      this.commitChanges();
      this.setDrug(null);
      this.setProduct(null);
    });
    if (process.env.NODE_ENV !== "development") {
      window.onbeforeunload = function () {
        return "Are you sure";
      };
    }
  },
};
</script>